import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/Index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/introduction/:id',
    name: 'introduction',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Introduction.vue')
  },
  {
    path: '/news/:id',
    name: 'newList',
    component: () => import(/* webpackChunkName: "about" */ '../views/News/Index.vue')
  },
  {
    path: '/activity/:id',
    name: 'activityList',
    component: () => import(/* webpackChunkName: "about" */ '../views/Activity/Index.vue')
  },
  {
    path: '/news/detail/:id',
    name: 'newDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/News/Detail.vue')
  },
  {
    path: '/kb/:id',
    name: 'kb',
    component: () => import(/* webpackChunkName: "about" */ '../views/Kb/Index.vue')
  },
  {
    path: '/standard/:id',
    name: 'standard',
    component: () => import(/* webpackChunkName: "about" */ '../views/Standard/Index.vue')
  },
  {
    path: '/standard/detail/:id',
    name: 'standardDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/Standard/Detail.vue')
  },
  {
    path: '/centigrade/:id',
    name: 'centigradeIndex',
    component: () => import(/* webpackChunkName: "about" */ '../views/Centigrade/Index.vue')
  },

  {
    path: "/m",
    name: "MHome",
    meta: {
      title: "首页",
      icon: "home",
      requireAuth: false,
    },
    component: () => import("@/views/mobile/home"),
    hidden: true,
  },
  {
    path: '/m-introduction/:id',
    name: 'MIntroduction',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/mobile/m-introduction.vue')
  },
  {
    path: '/m-news/:id',
    name: 'MNewList',
    component: () => import(/* webpackChunkName: "about" */ '@/views/mobile/m-news.vue')
  },
  {
    path: '/m-kb/:id',
    name: 'Mkb',
    component: () => import(/* webpackChunkName: "about" */ '@/views/mobile/m-kb.vue')
  },
  {
    path: '/m-centigrade/:id',
    name: 'Mcentigrade',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/mobile/m-centigrade.vue')
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router
